"use strict";

reportCreator.classy.controller({
    name: "ReportCreatorController",
    inject: ["$scope", "ArchiveYearsService", "ReportCreatorService", "SchoolModelService"],
    init: function()
    {
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.ReportCreatorService = this.ReportCreatorService;
        this.$.sort = {key: "", direction: 0};
        this.$.ReportCreatorService.resetReport();
    },
    setSort: function(col, dir) {
        this.$.sort = {key: col, direction: dir};
    },
    customSort: function(datarow) {
        if (this.$.sort.key==="name") {
            return datarow.Applicants[0].App_Last;
        }
        else if (this.$.sort.key==="amount") {
            return datarow.Value;
        }
    },
    print: function() {
        var newtab = window.open('', '_blank', 'height=400,width=800');
        newtab.document.write('<html><head><title></title>');
        newtab.document.write("<style> @page { size:auto; margin: 2.54cm 2.54cm 2.54cm 2.54cm font: arial; } table { width: 100%; } td { padding:.4em; text-align:center; }</style>");
        newtab.document.write('</head><body >');
        newtab.document.write($('.reports-body').html());
        newtab.document.write('</body></html>');
        newtab.document.close(); // necessary for IE >= 10
        newtab.focus(); // necessary for IE >= 10
        newtab.print();
        newtab.close();
        return true;
    },
    download: function()
    {
        var headers = [{name: "Applicants", id: "Applicants"}, {name: "Value", id: "Value"}];
        this.exportToCsv(headers, this.ReportCreatorService.results.results);
    },
    sort: function(field)
    {
        var sort = this.ReportCreatorService.getSort();
        if (sort.field == field)
            sort.reverse = !sort.reverse;
        else
        {
            sort.reverse = false;
            sort.field = field;
        }
        this.ReportCreatorService.setSort(sort.field, sort.reverse);
    },
    exportToCsv: function(headers, items)
    {
        var objectToString = function(obj)
        {
            var result = "";
            for (var prop in obj) //loop through the columns that are diplayed
            {
                if (prop != "$$hashKey")
                {
                    if (obj[prop] instanceof Array)
                        result += arrayToString(obj[prop]) + " ";
                    else if (obj[prop] instanceof Object)
                        result += objectToString(obj[prop]) + " ";
                    else
                        result += obj[prop] + " ";
                }
            }
            return result;
        };


        var arrayToString = function(arr)
        {
            var result = "";
            for(var i = 0; i < arr.length; i++)
            {
                if (arr[i] instanceof Array)
                    result = arrayToString(arr[i]) + String.fromCharCode(10);
                else if (arr[i] instanceof Object)
                    result += objectToString(arr[i]) + String.fromCharCode(10);
                else
                    result += arr[i] + String.fromCharCode(10);
            }
            return result;
        };

        //Preprocess data to convert arrays to strings
        for (var row in items) { // loop through each item place into csv string
            for (var col in headers) //loop through the columns that are diplayed
            {
                if (items[row][headers[col].id] instanceof Array)
                    items[row][headers[col].id] = arrayToString(items[row][headers[col].id]);
                else if (items[row][headers[col].id] instanceof Object)
                    items[row][headers[col].id] = objectToString(items[row][headers[col].id]);
            }
        }


        var csv = ""; //Export current view to a csv file
        for (var col in headers) { csv += headers[col].name + ","; } //add the header column
        csv += "\n";
        for (let row in items) { // loop through each item place into csv string
            for (var col in headers) //loop through the columns that are diplayed
            {
                if (items[row][headers[col].id] + "" == "NaN") //if value is NaN
                {
                    csv += ",";
                }
                else
                {
                    var val = (items[row][headers[col].id]+"")
                        .replace('\"', '\"')
                        .replace(/(<([^>]+)>)/ig,""); //strip html
                    csv += '"' + val + '",'
                }
            }
            csv += "\n";
        }


        var element = document.createElement("a");
        element.setAttribute("href", "data:attachment/csv;charset=utf-8," + encodeURI(csv));
        element.setAttribute("target", "_blank");
        element.setAttribute("download", "salesdata.csv");
        document.body.appendChild(element);
        element.click();
    }
});
